import { useEffect } from 'react';

const PUBLIC_HOSTS = ['dashflow.com.ar', 'www.dashflow.com.ar', 'unistock-zexev.ondigitalocean.app'];
const JSONLD_ID = 'ayuda-jsonld';

interface HeadMeta {
  title: string;
  description: string;
  /** Path canónico, p. ej. "/ayuda/como-cargar-un-producto". */
  path: string;
  jsonLd?: object | object[];
}

/**
 * Title, description, canonical y JSON-LD de las páginas del centro de ayuda.
 * Al salir de la página deja todo como estaba (index.html trae los de la home).
 * El canonical sigue la misma regla que index.html: solo en el dominio público, nunca en
 * los subdominios de las empresas.
 */
export const useHeadMeta = ({ title, description, path, jsonLd }: HeadMeta) => {
  const ld = jsonLd ? JSON.stringify(jsonLd) : '';
  useEffect(() => {
    const prevTitle = document.title;
    const descTag = document.querySelector('meta[name="description"]');
    const prevDesc = descTag?.getAttribute('content') || '';

    document.title = title;
    descTag?.setAttribute('content', description);

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const prevCanonical = canonical?.getAttribute('href') || null;
    const createdCanonical = !canonical && PUBLIC_HOSTS.includes(window.location.hostname);
    if (createdCanonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    if (canonical) canonical.href = `https://dashflow.com.ar${path}`;

    let script: HTMLScriptElement | null = null;
    if (ld) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = JSONLD_ID;
      script.text = ld;
      document.head.appendChild(script);
    }

    return () => {
      document.title = prevTitle;
      descTag?.setAttribute('content', prevDesc);
      if (createdCanonical) canonical?.remove();
      else if (canonical && prevCanonical !== null) canonical.href = prevCanonical;
      script?.remove();
    };
  }, [title, description, path, ld]);
};
